import App from 'next/app'
import Head from 'next/head'
import * as Sentry from '@sentry/nextjs'
import { UserContext } from '../components/UserProvider'
import ThemeModal from '../components/ThemeModal'
import { getUserInfo, getUserInfoServer } from '../fetch'
import { getUserSpecificDetails } from '../fetch/user'
import '@turingshequ/react-toast/src/index.sass'
import '@turingshequ/dropdown/src/index.sass'
import '@turingshequ/repl/src/repl.sass'
import 'styles/globals.sass'
import { useReducer, useLayoutEffect, useEffect } from 'react'
import redirectLogin, { getLoginPath } from '../fetch/redirectLogin'
import { reducer } from './models/app_page'
import { YdCourseApp } from '../components/YdCourseApp'
import { isYdCourseApp } from '../util'
import { DEPLOY_ENV } from '../util/constants'

const useEffectCustom =
  typeof window !== 'undefined' ? useLayoutEffect : useEffect

function MyApp({ Component, pageProps }) {
  const { userDetail } = pageProps
  useEffectCustom(() => {
    if (userDetail) {
      // 公参
      const { userIdentity, courseType, userId } = userDetail
      window._rlog.push([
        '_addPost',
        'loginStatus',
        userId ? '已登录' : '未登录',
      ])
      window._rlog.push(['_addPost', 'userIdentity', userIdentity])
      window._rlog.push(['_addPost', 'courseType', courseType])
    } else {
      window._rlog.push(['_addPost', 'loginStatus', '未登录'])
    }
  }, [userDetail])

  useEffectCustom(() => {
    let debuggerTimer

    function block() {
      debuggerTimer = setInterval(() => {
        (function () {
          return false
        }['constructor']('debugger')['call']())
      }, 50)
    }
    try {
      // only enable when production release
      if (DEPLOY_ENV === 'production') {
        block()
      }
    } catch (err) {
      /* */
    }

    return () => {
      clearInterval(debuggerTimer)
    }

  }, [])

  // eslint-disable-next-line react/prop-types
  const initState = {
    user: pageProps.user,
    themeModalStatus: 'hide',
    updateUnread: 0,
  }
  const [state, dispatch] = useReducer(reducer, initState)

  return (
    <>
      <Head>
        <title>有道小图灵创作社区-让想法变成现实</title>
        <link
          rel="icon"
          href="https://ydschool-video.nosdn.127.net/1564472204313logo.ico"
        />
      </Head>

      <UserContext.Provider value={{ ...state, dispatch }}>
        <Component {...pageProps} />
        <ThemeModal />
        <YdCourseApp />
      </UserContext.Provider>
    </>
  )
}

MyApp.getInitialProps = async function getInitialProps(appCtx) {
  const { ctx, Component } = appCtx
  let user = null

  const pageProps = await App.getInitialProps(appCtx)
  if (ctx.req || (!ctx.req && !isYdCourseApp())) {
    try {
      if (ctx.req) {
        user = await getUserInfoServer({
          cookie: ctx.req.headers.cookie,
        })
      } else {
        user = await getUserInfo()
      }
    } catch (err) {
      // catch no login
    }

    if (user) {
      Sentry.setTag('userId', user.userId)
    }

    if (Component.requiredLogin && !user) {
      if (ctx.res) {
        ctx.res.writeHead(302, {
          Location: getLoginPath(
            'https://' + ctx.req.headers.host + ctx.req.url
          ),
        })
        ctx.res.end()
      } else {
        redirectLogin()
      }
    }
  }

  let userDetail = null
  try {
    userDetail = await getUserSpecificDetails(
      ctx.req
        ? {
            cookie: ctx.req.headers.cookie,
          }
        : {}
    )
  } catch (_) {
    // 用户详情用于埋点使用，请求失败，也不能影响页面使用
  }

  return {
    pageProps: {
      ...pageProps,
      user: user,
      userDetail,
    },
  }
}

export default MyApp
